export default __webpack_public_path__ + "static/smear-test-c5962720772672f78c6bc27723d1df19.mp4";